/**
 * @author [jpcapelo]
 * @email [jhonnathanp27@gmail.com]
 * @create date 2021-11-10
 * @modify date 2021-11-10
 * @desc [description]
 */

import styled from 'styled-components'
import { color, space, typography, buttonStyle, border, position, flexbox, variant, layout, background, maxWidth, padding, borderRadius, height } from 'styled-system'

const Box = styled('div')(
    {},
    props => {
        return ({
            fontFamily: props.theme.mainFont
            //backgroundColor: props.theme.colors.bg1,
            // '&:hover': {
            //     outline: 'none',
            //     // borderColor: ,
            // },

            // backgroundColor: 'secondary',
            // backgroundColor: themeGet('colors.light-gray')(props),

        })
    },
    color,
    space,
    variant,
    layout,
    flexbox,
    background,
    position,
    border,
    maxWidth,
    padding,
    borderRadius,
    height
)

Box.defaultProps = {

    // variant: 'primary',

    // m: [1, 2, 3,4, 5, 6],
    //  m: [1, 2],
    p: [1],

}

export default Box;




/*  puedo pasar los colores del tema con gr1, gr2 */
export const GradientBgBox = styled(Box)`
background: linear-gradient(156.81deg, ${props => props?.theme?.color[props.gr1] ?? props.theme?.colors?.primary}  22.14%, ${props => props?.theme?.color[props.gr2] ?? props?.theme?.colors?.primaryDark} 87.91%);;
`;


